// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.listcard {
  border-radius: 7px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: rgba(99, 99, 99, 0.2) 1px 1px 5px 0px;
}

.selectedcard {
  background-color: #C3EFF4;
}

::ng-deep.endpointform {
  width: 50%;
}
::ng-deep.endpointform .mat-mdc-form-field {
  width: 100% !important;
  height: 5vh !important;
}
::ng-deep.endpointform .mat-mdc-form-field .mat-mdc-text-field-wrapper {
  height: 5vh !important;
}
::ng-deep.endpointform .mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex {
  height: 5vh !important;
}
::ng-deep.endpointform .mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mdc-notched-outline {
  height: 5vh !important;
}
::ng-deep.endpointform .mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mdc-notched-outline .mdc-floating-label {
  font-size: 12px !important;
  padding-bottom: 26px !important;
  color: black !important;
}
::ng-deep.endpointform .mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-form-field-infix {
  bottom: 13px !important;
  font-size: 12px !important;
}
::ng-deep.endpointform .mat-mdc-form-field .mat-mdc-form-field-subscript-wrapper {
  display: none !important;
}

::ng-deep.endpointformbig {
  width: 50%;
}
::ng-deep.endpointformbig .mat-mdc-form-field {
  width: 100% !important;
}
::ng-deep.endpointformbig .mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mdc-notched-outline .mdc-floating-label {
  font-size: 12px !important;
  padding-bottom: 26px !important;
  color: black !important;
}
::ng-deep.endpointformbig .mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-form-field-infix {
  padding-bottom: 0px !important;
  bottom: 13px !important;
  font-size: 12px !important;
}
::ng-deep.endpointformbig .mat-mdc-form-field .mat-mdc-form-field-subscript-wrapper {
  display: none !important;
}

::ng-deep.agentendpointpopup .modal-dialog {
  max-width: 73% !important;
  padding-top: 13%;
}
::ng-deep.agentendpointpopup .modal-dialog .modal-content .modal-header {
  height: 24px;
  color: white;
  background-color: #17a0b4;
  font-weight: 600;
  justify-content: center;
}

.deleteagentendpoint {
  background-color: rgba(255, 133, 133, 0.8784313725);
  border: 1px solid #821b1b;
  color: #821b1b;
  margin-left: 4%;
  cursor: pointer;
}

.deleteagentendpointdisabled {
  background-color: rgba(255, 133, 133, 0.8784313725);
  border: 1px solid #821b1b;
  color: #821b1b;
  margin-left: 4%;
  cursor: not-allowed;
}

.editagentendpoint {
  background-color: rgba(0, 0, 255, 0.1490196078);
  border: 1px solid #404090;
  color: blue;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/agents/agentendpoints/agentendpoints.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,qCAAA;EACA,iDAAA;AACJ;;AACA;EACI,yBAAA;AAEJ;;AAAA;EACI,UAAA;AAGJ;AAFA;EACI,sBAAA;EACA,sBAAA;AAIJ;AAHI;EACI,sBAAA;AAKR;AAJQ;EACI,sBAAA;AAMZ;AALQ;EACI,sBAAA;AAOZ;AANY;EACI,0BAAA;EACA,+BAAA;EACA,uBAAA;AAQhB;AALQ;EACI,uBAAA;EACA,0BAAA;AAOZ;AAHI;EACI,wBAAA;AAKR;;AADA;EACI,UAAA;AAIJ;AAHA;EACI,sBAAA;AAKJ;AADY;EACI,0BAAA;EACA,+BAAA;EACA,uBAAA;AAGhB;AAAQ;EACI,8BAAA;EACA,uBAAA;EACA,0BAAA;AAEZ;AAEI;EACI,wBAAA;AAAR;;AAMI;EACI,yBAAA;EACA,gBAAA;AAHR;AAKY;EACI,YAAA;EACA,YAAA;EACA,yBAAA;EACA,gBAAA;EACA,uBAAA;AAHhB;;AASA;EACI,mDAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;AANJ;;AAQA;EACI,mDAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;AALJ;;AAOA;EACI,+CAAA;EACA,yBAAA;EACA,WAAA;EACA,eAAA;AAJJ","sourcesContent":[".listcard{\r\n    border-radius: 7px;\r\n    border: 1px solid rgba(0, 0, 0, 0.08);\r\n    box-shadow: rgba(99, 99, 99, 0.2) 1px 1px 5px 0px;\r\n}\r\n.selectedcard{\r\n    background-color: #C3EFF4;\r\n}\r\n::ng-deep.endpointform{\r\n    width: 50%;\r\n.mat-mdc-form-field{\r\n    width: 100% !important;\r\n    height: 5vh !important;\r\n    .mat-mdc-text-field-wrapper{\r\n        height: 5vh !important;\r\n        .mat-mdc-form-field-flex{\r\n            height: 5vh !important;\r\n        .mdc-notched-outline{\r\n            height: 5vh !important;\r\n            .mdc-floating-label{\r\n                font-size: 12px !important;\r\n                padding-bottom: 26px !important;\r\n                color: black !important;\r\n            }\r\n        }\r\n        .mat-mdc-form-field-infix{\r\n            bottom: 13px !important;\r\n            font-size: 12px !important;\r\n        }\r\n    }\r\n    }\r\n    .mat-mdc-form-field-subscript-wrapper{\r\n        display: none !important;\r\n    }\r\n}\r\n}\r\n::ng-deep.endpointformbig{\r\n    width: 50%;\r\n.mat-mdc-form-field{\r\n    width: 100% !important;\r\n    .mat-mdc-text-field-wrapper{\r\n        .mat-mdc-form-field-flex{\r\n        .mdc-notched-outline{\r\n            .mdc-floating-label{\r\n                font-size: 12px !important;\r\n                padding-bottom: 26px !important;\r\n                color: black !important;\r\n            }\r\n        }\r\n        .mat-mdc-form-field-infix{\r\n            padding-bottom: 0px !important;\r\n            bottom: 13px !important;\r\n            font-size: 12px !important;\r\n        }\r\n    }\r\n    }\r\n    .mat-mdc-form-field-subscript-wrapper{\r\n        display: none !important;\r\n    }\r\n}\r\n\r\n}\r\n::ng-deep.agentendpointpopup{\r\n    .modal-dialog{\r\n        max-width: 73% !important;\r\n        padding-top: 13%;\r\n        .modal-content{\r\n            .modal-header{\r\n                height: 24px;\r\n                color: white;\r\n                background-color: #17a0b4;\r\n                font-weight: 600;\r\n                justify-content: center;\r\n            }  \r\n        }\r\n    }\r\n}\r\n\r\n.deleteagentendpoint{\r\n    background-color: #ff8585e0;\r\n    border: 1px solid #821b1b;\r\n    color: #821b1b;\r\n    margin-left: 4%;\r\n    cursor: pointer;\r\n}\r\n.deleteagentendpointdisabled{\r\n    background-color: #ff8585e0;\r\n    border: 1px solid #821b1b;\r\n    color: #821b1b;\r\n    margin-left: 4%;\r\n    cursor: not-allowed;\r\n}\r\n.editagentendpoint{\r\n    background-color: #0000ff26;\r\n    border: 1px solid #404090;\r\n    color: blue;\r\n    cursor: pointer;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
